/* eslint-disable no-param-reassign */
import * as req from '_common/utils/req';

import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取当前可提现币种
   * @returns {Promise<any>}
   */
  getCurrendies(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.SUB_CURRENCY_LIST, { params })
        .then((res) => {
          res.data.forEach((item) => {
            const currencyItem = item;
            currencyItem.value = item.currencyId;
            currencyItem.label = item.currency;
            if (
              currencyItem.subCurrencies &&
              currencyItem.subCurrencies.length > 0
            ) {
              currencyItem.subCurrencies.forEach((subItem) => {
                subItem.value = subItem.currencyId;
                subItem.currency = subItem.name;
              });
            }
          });
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取当前币种 提现信息
   * @returns {Promise<any>}
   */
  getWithdrawDetail(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_AMOUNT, { params })
        .then((res) => {
          if (res.data.lastAddress?.targetUserSubName?.length) {
            res.data.lastAddress.targetUserType = `${res.data.lastAddress?.targetUserType}（${res.data.lastAddress?.targetUserSubName}）`;
          }
          // mock
          if (res.data.lastAddress?.targetUserType?.includes('本人以外')) {
            // res.data.lastAddress.targetUserType = '本人以外（法人）';
            // res.data.lastAddress.targetPersonalLastName = 'カナ';
            // res.data.lastAddress.targetPersonalFirstName = 'カナ';
            // res.data.lastAddress.targetPersonalLastNameEn = 'name';
            // res.data.lastAddress.targetPersonalFirstNameEn = 'name';
            // res.data.lastAddress.legalEntity = '株式会社';
            // res.data.lastAddress.legalEntityPos = {
            //   id: 1,
            //   value: 1,
            //   label: '法人格前',
            // };
            // res.data.lastAddress.targetLegalName = 'カナ';
            // res.data.lastAddress.targetLegalNameEn = 'name';
            if (res.data.lastAddress?.targetUserSubName?.length === 0) {
              res.data.lastAddress.targetUserType = ``;
            }
            res.data.lastAddress.legalEntity =
              res.data.lastAddress.legalEntityStr;
            res.data.lastAddress.legalEntityPos = {
              id: res.data.lastAddress.legalEntityPos,
              value: res.data.lastAddress.legalEntityPos,
              label: res.data.lastAddress.legalEntityPosStr,
            };
          }
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取当前币种 地址列表
   * @returns {Promise<any>}
   */
  getAddressList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_ADDRESS_LIST, { params })
        .then((res) => {
          res.data.addressList.forEach((item) => {
            const addressItem = item;
            addressItem.disabled = !item.canWithdraw;
            addressItem.label = item.title;
            if (addressItem.targetUserSubName?.length) {
              addressItem.targetUserType = `${addressItem.targetUserType}（${addressItem.targetUserSubName}）`;
            }
            // mock
            if (addressItem.targetUserType?.includes('本人以外')) {
              // addressItem.targetUserType = '本人以外（法人）';
              // addressItem.targetPersonalLastName = 'カナ';
              // addressItem.targetPersonalFirstName = 'カナ';
              // addressItem.targetPersonalLastNameEn = 'name';
              // addressItem.targetPersonalFirstNameEn = 'name';
              // addressItem.legalEntity = '株式会社';
              // addressItem.legalEntityPos = {
              //   id: 1,
              //   value: 1,
              //   label: '法人格前',
              // };
              // addressItem.targetLegalName = 'カナ';
              // addressItem.targetLegalNameEn = 'name';
              if (addressItem.targetUserSubName?.length === 0) {
                addressItem.targetUserType = ``;
              }
              addressItem.legalEntity = addressItem.legalEntityStr;
              addressItem.legalEntityPos = {
                id: addressItem.legalEntityPos,
                value: addressItem.legalEntityPos,
                label: addressItem.legalEntityPosStr,
              };
            }
          });
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取当前币种 支持账户类型
   * @returns {Promise<any>}
   */
  getAddressType(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_TARGET_LIST, { params })
        .then((res) => {
          res.data.withdrawTarget.forEach((item) => {
            const targetItem = item;
            targetItem.value = item.targetType;
            targetItem.label = item.name;
          });
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 获取用户是否可以提现
   */
  getCheckInfo() {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.CHECK_WITHDRAW_LIST)
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 检查当前输入地址是否合法
   * @returns {Promise<any>}
   */
  checkAddress(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_CHECK_ADDRESS, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 确认提币
   * @returns {Promise<any>}
   */
  confirmWithdraw(params) {
    return new Promise((resolve, reject) => {
      req.postData(
        URL.POST_WITHDRAW_CONFIRM,
        params,
        (res) => {
          resolve(res.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  /**
   * 确认提币 - 内部转账专用
   * @returns {Promise<any>}
   */
  confirmWithdrawInner(params) {
    return new Promise((resolve, reject) => {
      req.postData(
        URL.POST_WITHDRAW_CONFIRM,
        params,
        (res) => {
          resolve(res.data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  /**
   *  提币历史
   */
  getWithdrawList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_LIST, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 删除提现地址
   */
  deleteAddress(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .postForm(URL.POST_WITHDRAW_ADDRESS_DELETE, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 取消提现
   */
  cancelWithdraw(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .postForm(URL.CANCEL_WITHDRAW, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * 确认增加地址
   * @param params
   * @returns {Promise}
   */
  confirmAddress(params) {
    return new Promise((resolve, reject) => {
      req.postData(
        URL.ADD_ADDRESS,
        params,
        (res) => {
          resolve(res.data);
        },
        (res) => {
          reject(res);
        }
      );
    });
  },
  /**
   * Get WithdrawReason List
   * @param params
   * @returns {Promise}
   */
  getWithdrawReasonList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_REASON_LIST, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * Get Withdraw target config
   * @returns {Promise}
   */
  getWithdrawTargetConfig() {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_WITHDRAW_TARGET_CONFIG, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },
  /**
   * Compliance check before withdrawal
   * @param params {Object}
   * @returns {Promise}
   */
  checkWithdraw(params) {
    return new Promise((resolve, reject) => {
      req.postData(
        URL.WITHDRAW_CHECK,
        params,
        (res) => {
          resolve(res.data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  },
};
